import { render, staticRenderFns } from "./simpleSnotifyInfo.vue?vue&type=template&id=3f159cf2&scoped=true"
import script from "./simpleSnotifyInfo.vue?vue&type=script&scoped=true&lang=js"
export * from "./simpleSnotifyInfo.vue?vue&type=script&scoped=true&lang=js"
import style0 from "./simpleSnotifyInfo.vue?vue&type=style&index=0&id=3f159cf2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f159cf2",
  null
  
)

export default component.exports